import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../Header";

const OneCompilerIframe = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [NavigationUrl, setNavigationUrl] = useState("");

  useEffect(() => {
    let url = location.state?.Url || sessionStorage.getItem("OneCompilerUrl");

    if (!url) {
      navigate("/codomo/home");
      return;
    }

    // Convert Scratch /editor → /embed
    if (url.includes("scratch.mit.edu") && url.includes("editor")) {
      url = url.replace("editor", "embed");
    }

    setNavigationUrl(url);
  }, []);

  return (
    <>
      <Header />
      <div className="nav-tab-wrapper tabs section-padding">
        <div className="container">
          <div style={{ height: "100vh" }}>
            <iframe
              src={NavigationUrl}
              frameBorder="0"
              style={{ width: "100%", height: "600px" }}
              allow="fullscreen"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default OneCompilerIframe;
